import { useDispatch, useSelector } from "react-redux";
import { authMapState } from "../../redux/auth.mapstate";
import { setAuthDataAction } from "../../redux/auth.action";
import setAuthHeaderAxios from "../../utils/setAuthToken";
import { authAPI } from "../../service/authAPI";
import { useMutation, useQueryClient } from "react-query";
import { CallbackFunction } from "../../../../common/types/callback.types";
import { Auth } from "../../types/auth.types";
import { AxiosError } from "axios";
import { User, UserOrga } from "../../../user/types/user.types";


export interface Config {}

/**
 * Auth core hook
 * @param config 
 * @returns 
 */
export default function useAuthCore(config?: Config) {
  const dispatch = useDispatch();
  const { auth: authState } = useSelector(authMapState);
  const queryClient = useQueryClient(); 
  const loginQuery = useMutation({
    mutationFn: (
      { email, password }: { email: string; password: string},
      callback?: CallbackFunction<Auth, AxiosError>
    ) => {
      return authAPI
        .login(email, password)
        .then((data) => {
          if (data && data.user && data.token) {
            setUserAuthenticated({ user: data.user, token: data.token, userOrga: data?.user_orga_list?.[0] || undefined });
          }

          if (callback) {
            callback({ result: data });
          }
         return Promise.resolve(data);
        })
        .catch((error) => {
          logOutUser();
          if (callback) {
            callback({ error });
          }
          return Promise.reject(error);
        });
    },
  });

  const setUserAuthenticated = ({
    user,
    token,
    userOrga,
  }: {
    user: User;
    token: string;
    userOrga?: UserOrga;
  }) => {
    setAuthHeaderAxios({ token, userId: user.user_id });
    dispatch(setAuthDataAction({ token, user, userOrga }));
  };

  const authenticateByURL = () => {
    queryClient.clear();
    let token = new URLSearchParams(window.location.search).get("t");

    let userId = new URLSearchParams(window.location.search).get("userId");

    if (token && userId) {
      //Todo
      //setUserAuthenticated({email: '', user: {user_id: userId}, token})
    }
  };

  const logOutUser = () => {
    queryClient.clear();
    setAuthHeaderAxios(null);
    dispatch(setAuthDataAction(null));

  };

  const getUserIsAuthenticated = () => {
    return authState.authData !== null;
  };

  const setHeaderAuthToRequest = () => {
    if (authState.authData) {
      setAuthHeaderAxios({
        token: authState.authData.token,
        userId: authState.authData.user?.user_id,
        userOrgaId: authState.authData.userOrga?.user_orga_id,
      });
    }
  };

  const getUserId = () => {
    return authState.authData?.user?.user_id || null;
  };

  const setUserOrgaLogged = (userOrga: UserOrga) => {
    queryClient.clear();
    dispatch(
      setAuthDataAction({
     ...authState.authData,
        userOrga,
      })
    );

    setHeaderAuthToRequest();
  }

  const loginUser = ({
    email,
    password,

  }: {
    email: string;
    password: string;
  }) => {
    queryClient.clear();
   loginQuery.mutate({ email, password });
  };

  return {
    authenticateByURL,
    authState: authState,
    logOutUser,
    getUserIsAuthenticated,
    setHeaderAuthToRequest,
    getUserId,
    loginUser,
    userLogged: authState.authData?.user,
    userRole: authState.authData?.userOrga?.user_orga_role,
    loginQuery: {
      ...loginQuery, 
      error: loginQuery.error as AxiosError
    },
    isLoading: loginQuery.isLoading,
    isError: loginQuery.isError,
    error: loginQuery.error as AxiosError,
    isLogged: authState.authData?.user ? true : false,
    organizationIdUser: authState.authData?.userOrga?.organization_id,
    setUserOrgaLogged
  };
}
